// extracted by mini-css-extract-plugin
module.exports = {"youtube":"Movie_youtube__Xewnl"};